import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
  faHome,
  faGraduationCap,
  faCheckSquare,
  faCoffee,
  faSlidersH,
  faUniversity,
  faCodeBranch,
  faTimes,
  faSmile,
  faStar,
  faCopy,
  faSearch,
  faCog,
  faQuestionCircle,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  fab,
  faHome,
  faGraduationCap,
  faCheckSquare,
  faCoffee,
  faSlidersH,
  faUniversity,
  faCodeBranch,
  faTimes,
  faSmile,
  faStar,
  faCopy,
  faSearch,
  faCog,
  faQuestionCircle,
  faEnvelope
);
